/**
 * Accordion — collapsible panels mit data-bs-* Markup
 *
 *   <button data-bs-toggle="collapse" data-bs-target="#id" aria-expanded="false">
 *   <div id="id" class="accordion-collapse collapse" data-bs-parent="#group">…</div>
 *
 * Verhalten:
 *  - Toggle .show auf das Target
 *  - aria-expanded synchronisiert
 *  - data-bs-parent → andere offene Items im Group schließen
 *  - max-height-Animation übernimmt CSS (.accordion-collapse.show)
 */

function toggle(button) {
  const targetSelector = button.getAttribute("data-bs-target");
  if (!targetSelector) return;
  const target = document.querySelector(targetSelector);
  if (!target) return;

  const willOpen = !target.classList.contains("show");
  const parentSelector = target.getAttribute("data-bs-parent");

  if (willOpen && parentSelector) {
    const parent = document.querySelector(parentSelector);
    if (parent) {
      parent.querySelectorAll(".accordion-collapse.show").forEach((openItem) => {
        openItem.classList.remove("show");
        const associatedButton = document.querySelector(
          `[data-bs-target="#${openItem.id}"]`
        );
        if (associatedButton) {
          associatedButton.setAttribute("aria-expanded", "false");
          associatedButton.classList.add("collapsed");
        }
      });
    }
  }

  target.classList.toggle("show", willOpen);
  button.setAttribute("aria-expanded", willOpen ? "true" : "false");
  button.classList.toggle("collapsed", !willOpen);
}

function handleClick(event) {
  const button = event.target.closest(
    '[data-bs-toggle="collapse"]'
  );
  if (!button) return;
  event.preventDefault();
  toggle(button);
}

export function init() {
  document.addEventListener("click", handleClick);
}
